import imageActions from '../image-actions';

const handleInvalidImages = (errors, dispatch, translator) => {
    const displayTexts = [];
    let invalidImageCount = 0;
    errors.forEach(error => {
        let invalidImageIds = error.message.split(',');
        invalidImageIds.forEach(id => {
            dispatch(imageActions.removeImageWithId(id));
            invalidImageCount++;
        });
    });
    if (invalidImageCount > 0) {
        displayTexts.push(
            translator('syi_publish_error_invalid_image', {
                count: invalidImageCount
            })
        );
    }
    return displayTexts;
};

const translateErrorCode = (error, translator) => {
    switch (error.errorCode) {
        case 'AlreadyPublished':
            return translator('syi_publish_error_alreadypublished');
        case 'BuyItNowPriceNotLargerThanOpeningPrice':
            return translator(
                'syi_publish_error_buyitnowpricenotlargerthanopeningprice'
            );
        case 'BuyItNowPriceNotLargerThanReservePrice':
            return translator(
                'syi_publish_error_buyitnowpricenotlargerthanreserveprice'
            );
        case 'BuyItNowPriceTooLarge':
            return translator('syi_publish_error_buyitnowpricetoolarge');
        case 'BuyItNowPriceUnset':
            return translator('syi_publish_error_buyitnowpriceunset');
        case 'CampaignCodeInvalid':
            return translator('syi_publish_error_campaigncodeinvalid');
        case 'CategoryContainsTooManyItems':
            return translator('syi_publish_error_categorycontainstoomanyitems');
        case 'CategoryDoesNotSupportBin':
            return translator('syi_publish_error_categorydoesnotsupportbin');
        case 'CategoryDoesNotSupportUsedItems':
            return translator(
                'syi_publish_error_categorydoesnotsupportuseditems'
            );
        case 'CategoryIdUnknown':
            return translator('syi_publish_error_categoryidunknown');
        case 'CustomEndDateTooLate':
            return translator('syi_publish_error_customenddatetoolate');
        case 'CustomEndDateTooSoon':
            return translator('syi_publish_error_customenddatetoosoon');
        case 'DisplayHighlightedCannotBeRemoved':
            return translator(
                'syi_publish_error_displayhighlightedcannotberemoved'
            );
        case 'DisplayPromotedCannotBeRemoved':
            return translator(
                'syi_publish_error_displaypromotedcannotberemoved'
            );
        case 'DurationNotAllowed':
            return translator('syi_publish_error_durationnotallowed');
        case 'ImagesTooFew':
            return translator('syi_publish_error_imagestoofew');
        case 'ImagesTooMany':
            return translator('syi_publish_error_imagestoomany');
        case 'ItemHasBidsAndCannotBeChanged':
            return translator(
                'syi_publish_error_itemhasbidsandcannotbechanged'
            );
        case 'LongDescriptionCannotBeEmpty':
            return translator('syi_publish_error_longdescriptioncannotbeempty');
        case 'LongDescriptionTooLong':
            return translator('syi_publish_error_longdescriptiontoolong');
        case 'MemberIsActiveInternationalBuyer':
            return translator(
                'syi_publish_error_memberisactiveinternationalbuyer'
            );
        case 'MemberIsSuspended':
            return translator('syi_publish_error_memberissuspended');
        case 'MemberNotAllowedToListImmeditateEndingItems':
            return translator(
                'syi_publish_error_membernotallowedtolistimmeditateendingitems'
            );
        case 'OpeningPriceBelowOne':
            return translator('syi_publish_error_openingpricebelowone');
        case 'OpeningPriceTooLarge':
            return translator('syi_publish_error_openingpricetoolarge');
        case 'OwnReferenceTooLong':
            return translator('syi_publish_error_ownreferencetoolong');
        case 'PriceBelowOne':
            return translator('syi_publish_error_pricebelowone');
        case 'PriceBelowZero':
            return translator('syi_publish_error_pricebelowzero');
        case 'ReservePriceNotLargerThanOpeningPrice':
            return translator(
                'syi_publish_error_reservepricenotlargerthanopeningprice'
            );
        case 'ReservePriceTooLarge':
            return translator('syi_publish_error_reservepricetoolarge');
        case 'ShippingCostBelowZero':
            return translator('syi_publish_error_shippingcostbelowzero');
        case 'ShippingOptionsCannotBeEmpty':
            return translator('syi_publish_error_shippingoptionscannotbeempty');
        case 'ShippingOptionsCountTooLarge':
            return translator('syi_publish_error_shippingoptionscounttoolarge');
        case 'ShippingOptionsMoreThanOneWithTakeawayOnly':
            return translator(
                'syi_publish_error_shippingoptionsmorethanonewithtakeawayonly'
            );
        case 'ShortDescriptionCannotBeEmpty':
            return translator(
                'syi_publish_error_shortdescriptioncannotbeempty'
            );
        case 'ShortDescriptionTooLong':
            return translator('syi_publish_error_shortdescriptiontoolong');
        case 'UnknownError':
            return translator('syi_publish_error_unknownerror');
    }

    return error.message;
};

export const handleServerValidationError = (errors, dispatch, translator) => {
    const invalidImageErrorCodes = ['DeletedImage', 'MissingImage'];
    const imageErrorFilter = error =>
        invalidImageErrorCodes.includes(error.errorCode);
    const nonImageErrorFilter = error =>
        !invalidImageErrorCodes.includes(error.errorCode);

    const imageErrors = errors.filter(imageErrorFilter);
    const nonImageErrors = errors.filter(nonImageErrorFilter);

    const imageErrorDisplayTexts = handleInvalidImages(
        imageErrors,
        dispatch,
        translator
    );
    const nonImageErrorDisplayTexts = nonImageErrors.map(error =>
        translateErrorCode(error, translator)
    );

    const errorDisplayTexts = imageErrorDisplayTexts.concat(
        nonImageErrorDisplayTexts
    );
    const errorDisplayText = errorDisplayTexts.join(' ').trim();
    dispatch({
        type: 'SET_PUBLISH_FAILED',
        reasonDisplayText: errorDisplayText ? errorDisplayText : null
    });
};
